<template>
	<div class="breadcrumbs">
		<template v-for="(item, index) in steps" :key="index">

			<div v-if="index != 0" class="arrow"><!-- Arrow --></div>

			<!-- is-valid doesn't compute -->
			<crumbs :step-name="item" :step-number="index" :is-valid="index < currentStep"></crumbs>

		</template>
	</div>
</template>

<!-- ================================================================================== -->

<script>
	import Crumbs from '@/components/Crumbs.vue';

	export default {
		name:"BreadCrumbs",

		components: {
			Crumbs,
		},

		props: {
			steps: {
				type: Array,
				required: true
			},
			currentStep: {
				type: Number,
				required: true
			}
		},
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>
	$small_max : 559px;
	$medium_min: 560px;
	$medium_max: 859px;
	$big_min: 860px;

	.breadcrumbs {
		display: grid;
		width:100%;
		max-width:744+188px;



		@media screen and (max-width : $small_max) {
			margin: 0 auto;
		}

		@media screen and (min-width : $medium_min) {
			margin: 0 auto;
			text-align: center;
		}

		@media screen and (max-width : 1024px) {
			align-items: center;
			grid-template-columns: 1fr 1fr;
			letter-spacing: 0;
		}
		

		@media screen and (min-width : $big_min) {
			grid-template-columns: 180px 8px 180px 8px 180px 8px 180px 8px 180px;
			margin: 40px auto;
			max-width:744+188px;
			justify-content: center;
		}

		@media screen and (min-width: $big_min) and (max-width: 1070px){
			transform: scale(0.8);
		}


	}

	.arrow {
		height:8px;
		width:6px;
		padding-top:70px;
		background: url('../assets/img/arrow.svg') no-repeat center center / contain;

		@media screen and (max-width : $small_max) {
			
		}
		@media screen and (min-width : $medium_min) {
			img {
				//				margin-top:20px;
			}
		}
		@media screen and (max-width : $medium_max) {
			display: none;
		}
		@media screen and (min-width : $big_min) {
			img {
				//				 margin-top:30px;
			}
		}

	}


</style>
